import React from "react"
import { FormControl, Row, Form } from "react-bootstrap"
import Text from "../../../../_components/Text"
import Modal from "../../../../_components/Modal"
import Button from "../../../../_components/Button"
import LoadingInput from "../../../../_components/LoadingInput"
import CurrencyInput from "react-currency-input"
import AppContext from "../../context"
import styled from "styled-components"
import { getProduct, createProduct, updateProduct, validateProductRefCode } from "../../../../api/products"
import { getUnits, getCategories, getMaxCode, getICMSList, searchNCM, searchCFOP, searchCEST } from "../../../../api/products"
import { createUnit, createCategory } from "../../../../api/products"
import { getIPI, getPIS, getCOFINS, getIBSCBSList } from "../../../../api/products/taxes"
import CreateIPI from "../../../Fiscal/Taxes/IPI/Template"
import CreatePIS from "../../../Fiscal/Taxes/PIS/Template"
import CreateCOFINS from "../../../Fiscal/Taxes/COFINS/Template"
import * as colors from "../../../../assets/_base/colors"
import { toast } from "react-toastify";
import { parseQueryString } from "../../../../utils"
import { Template as CreateICMS } from "../../../Fiscal/Taxes/ICMS"
import { Template as CreateIBSCBS } from "../../../Fiscal/Taxes/IBSCBS"
import { updateProductStock } from "../../../../api/stocks"

import { searchBarcode, deactivate } from "../../../../api/products"
import ButtonImportCSV from "../imports/ProductCSV/Button"

import { _Input } from "../../../../_components/Input"

import CheckBox from "../../../../_components/Checkbox"

import Page from "../../../../_components/Layout/Page"
import Column from "../../../../_components/Layout/Column"

import FilterProducts from "../components/Filter"
import NoCertificateWarning from "../../_components/NoCertificateWarning"
import { useInitData, useProductData } from "./hooks"
import { updateBranch } from "../../../../api/branches"
import { calculateProfitMargin } from "../../../../utils/profitMargin"


const CFOP_CODES_FUEL = [
    "5650",
    "5651",
    "5652",
    "5653",
    "5654",
    "5655",
    "5656",
    "5657",
    "5658",
    "5659",
    "5660",
    "5661",
    "5662",
    "5663",
    "5664",
    "5665",
    "5666",
    "5667",
]

const SimpleButton = styled.p`
    margin-top: 7px;
    padding: 2px;
    color: ${colors.darkBlue};
    cursor: pointer;
    font-weight: bold;
`

const ScrollableContainer = styled.div`
    margin-top: -10px;
    max-height: 180px;
    overflow-y: auto;
`;

const updateBranchIsFiscal = fiscal => {
    let branchData = localStorage.getItem("easygestorweb_current_branch")
    if (branchData) {
        branchData = JSON.parse(branchData)
        branchData.address = {
            ...branchData.address,
            state_location: branchData.address.state_id,
            city_location: branchData.address.city_id,
        }

        branchData.branch = {
            is_fiscal: fiscal,
            aliquota_credito: 1,
            main_company: true
        }

        updateBranch(branchData.id, branchData).then(branch => {
            localStorage.setItem("easygestorweb_current_branch", JSON.stringify(branch))
        })
    }
}


export default props => {
    const context = React.useContext(AppContext)

    const stockSectionRef = React.useRef(null)

    const [loading, setLoading] = React.useState(true)
    const [n, setN] = React.useState(0)
    const [isFiscal, setIsFical] = React.useState(false)
    const [data, setData] = React.useState({ barcode: "" })
    const [units, setUnits] = React.useState([])
    const [categories, setCategories] = React.useState([])
    const [taxes, setTaxes] = React.useState({ icms: [], ipi: [], pis: [], cofins: [], ibs_cbs: [] })
    const [fiscalCodes, setFicalCodes] = React.useState({ ncm: [], cfop: [], cest: [] })
    const [isToggled, setIsToggled] = React.useState(true);
    const [showModalSearch, setShowModalSearch] = React.useState(false)
    const [showIBSCBS, setShowIBSCBS] = React.useState(false)
    const [showIcmsAlert, setShowIcmsAlert] = React.useState(false) // eslint-disable-line no-unused-vars

    const parseIdFromProductPath = useInitData()
    const adaptProductData = useProductData()

    function handleToggle() {
        setIsToggled(!isToggled)
    }
    function containsUnicodeCharacter(input) {
        for (let i = 0; i < input.length; i++) {

            if (input.charCodeAt(i) > 127 && !/[a-zA-Zçáéíóúâêôãõ]/.test(input[i])) {
                return true;
            }
        }
        return false;
    }
    function onChange({ target }) {
        const { name: key, value } = target
        if (key === "ref_code") {
            validateRefCode(value)
        }

        if (key.includes(":")) {
            const [father, child] = key.split(":")
            setData(prev => {
                const isSearchField = ["ncm", "cfop", "cest"].includes(child);
                return {
                    ...prev,
                    fiscal: {
                        ...prev.fiscal,
                        [child]: isSearchField ? null : (value === "" ? null : value)
                    }
                }
            })
            if (key === "fiscal:template_icms" && value) {
                setShowIcmsAlert(false)
                try {
                    document.querySelector(`[name="fiscal:template_icms"]`).classList.remove("is-invalid")
                } catch (error) { }
            }
        } else {
            setData(prev => ({
                ...prev,
                [key]: value
            }))
        }
        if (key === "ref_code") {
            if (containsUnicodeCharacter(value)) {
                setData(prev => ({
                    ...prev,
                    ref_code: "",
                }))
            } else {
                setData(prev => ({
                    ...prev,
                    ref_code: value,
                }))
            }
        }
        if (key === "name") {
            setData(prev => ({
                ...prev,
                name: value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[<>~`´^°\\|]/g, '')
            }))
        }
        if (key === "fiscal:ncm") {
            setData(prev => ({
                ...prev,
                ncmCode: value
            }))
            if (value.length >= 6) {
                setLoading(true)
                searchNCM({ code: value })
                    .then(data => {
                        if (data.length === 0) {

                        } else if (data.length === 1) {
                            setFiscalCode("ncm", data[0])
                            setFicalCodes(prev => ({
                                ...prev,
                                ncm: []
                            }))
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                ncm: data
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:ncm"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "fiscal:cfop") {
            setData(prev => ({
                ...prev,
                cfopCode: value
            }))
            if (value.length === 4) {
                setLoading(true)
                searchCFOP({ code: value })
                    .then(cfop => {
                        if (cfop.length === 0) {

                        } else if (cfop.length === 1) {
                            setFiscalCode("cfop", cfop[0])
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                cfop
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:cfop"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "fiscal:cest") {
            setData(prev => ({
                ...prev,
                cestCode: value
            }))
            if (value.length >= 3) {
                setLoading(true)
                searchCEST({ code: value })
                    .then(data => {
                        if (data.length === 0) {
                        } else if (data.length === 1) {
                            setFiscalCode("cest", data[0])
                            setFicalCodes(prev => ({
                                ...prev,
                                cest: []
                            }))
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                cest: data
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:cest"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "stock_quantity") {
            setData(prev => {
                let { stock } = prev
                if (stock === undefined) {
                    stock = {
                        quantity: value
                    }
                } else {
                    stock.quantity = value
                }
                return {
                    ...prev,
                    stock
                }
            })
        } else if (key === "fiscal:anp_description") {
            setData(prev => ({
                ...prev,
                ANPDescription: value
            }))
        } else if (key === "fiscal:anp_code") {
            setData(prev => ({
                ...prev,
                ANPCode: value
            }))
        }

    }
    function validateRefCode(value) {
        setLoading(true);
        validateProductRefCode(value)
            .then(() => {
                try {
                    const input = document.querySelector("[name=ref_code]");
                    input.focus();
                    input.classList.remove("is-invalid");
                } catch (error) { }
            })
            .catch((err) => {
                try {
                    const input = document.querySelector("[name=ref_code]");
                    input.focus();
                    input.classList.add("is-invalid");
                } catch (error) { }
            })
            .finally(() => {
                setLoading(false);
                try {
                    document.querySelector("[name=ref_code]").focus();
                } catch (error) { }
            });
    }
    function setFiscalCode(code, obj) {
        setData(prev => ({
            ...prev,
            [`${code}Code`]: obj.code,
            [`${code}Description`]: obj.description,
            fiscal: {
                ...prev.fiscal || {},
                [code]: obj.id
            }
        }))
        setFicalCodes(prev => ({
            ...prev,
            ncm: [],
            cfop: [],
            cest: []
        }))
        if (code === "template_icms") {
            setShowIcmsAlert(false)
            try {
                document.querySelector(`[name="fiscal:template_icms"]`).classList.remove("is-invalid")
            } catch (error) { }
        }
    }

    function basicData() {
        return [getMaxCode().then(), getUnits().then(), getCategories().then()]
    }
    function loadTaxes() {
        return [getICMSList().then(), getIPI().then(), getPIS(), getCOFINS().then(), getIBSCBSList().then()]
    }
    function onSave(e) {
        e.preventDefault()


        let isValid = true

        if (!data["name"]) {
            toast.warn(<Text color="white">Informe a descrição do produto</Text>, {
                position: "top-center",
                toastId: "error-product-without-description"
            })
        }
        if (!data["price"]) {
            toast.warn(<Text color="white">Informe o preço de venda do produto</Text>, {
                position: "top-center",
                toastId: "error-product-without-price"
            })
        }
        if (!data["ref_code"]) {
            toast.warn(<Text color="white">Informe o código do produto</Text>, {
                position: "top-center",
                toastId: "error-product-without-ref_code"
            })
        }

        let fields = ['name', 'price', 'unit', 'ref_code']
        let fiscalFields = ["fiscal:ncm", "fiscal:cfop", "fiscal:template_icms"]

        if (isFiscal) {
            fields = fields.concat(fiscalFields)

            if (data.ncmCode && (!data.fiscal || !data.fiscal.ncm)) {
                toast.warn(<Text color="white">O NCM informado ({data.ncmCode}) não está cadastrado na base de dados.</Text>, {
                    position: "top-center",
                    toastId: "error-ncm-not-found"
                })
                isValid = false
            } else if (!data.fiscal || !data.fiscal.ncm) {
                toast.warn(<Text color="white">Por favor, pesquise e selecione um NCM válido.</Text>, {
                    position: "top-center",
                    toastId: "error-ncm-required"
                })
                isValid = false
            }
        }

        for (let field of fields) {
            const toggleClass = act => {
                try {
                    document.querySelector(`[name="${field}"]`).classList[act]("is-invalid")
                } catch (error) { }
            }
            if (field.includes(":")) {
                const [father, child] = field.split(":")
                if (!data[father]) {
                    toggleClass("add")
                    isValid = false
                    if (field === "fiscal:template_icms") {
                        setShowIcmsAlert(true)
                    }
                } else {
                    if (!data[father][child]) {
                        toggleClass("add")
                        isValid = false
                        if (field === "fiscal:template_icms") {
                            setShowIcmsAlert(true)
                        }
                    } else {
                        toggleClass("remove")
                        if (field === "fiscal:template_icms") {
                            setShowIcmsAlert(false)
                        }
                    }
                }
            } else if (!data[field]) {
                toggleClass("add")
                isValid = false
            } else {
                toggleClass("remove")
            }
        }
        if (!isValid) {
            window.scrollTo({ top: 0, behavior: "smooth" })
            return
        }
        if (document.querySelectorAll(".is-invalid").length > 0) {
            window.scrollTo({ top: 0, behavior: "smooth" })
            return
        }
        if (data.stock) {
            data.stock.quantity = data.stock_quantity
        }
        if (data.fiscal) {
            if (data.ANPCode && data.ANPDescription) {
                data.fiscal.anp_code = data.ANPCode
                data.fiscal.anp_description = data.ANPDescription
            }
            if (!data.cestCode) {
                data.fiscal.cest = null
            }
        }
        setLoading(true)
        const request = data.id ? updateProduct : createProduct
        request(data)
            .then(data => {
                toast.success("Produto salvo com sucesso!", { position: "top-center" })
                if (props.onSave) {
                    setLoading(false)
                    setData({ barcode: "" })
                    props.onSave(data)
                } else {
                    window.scrollTo({ top: 0, behavior: "smooth" })
                    const redirect = () => window.location.href = `/products/`
                    setTimeout(redirect, 3000)
                }
            })
            .catch(error => {
                if (error.ref_code_already_exists) {
                    validateRefCode(data.ref_code)
                }
                setLoading(false)
            })
    }
    function onSaveNewTemplate(obj, taxName) {
        const tax = taxes[taxName] || []
        tax.push(obj)
        setTaxes({ ...taxes, [taxName]: [] })
        const update = () => {
            setTaxes({ ...taxes, [taxName]: tax })
            setFiscalCode(`template_${taxName}`, obj)
            setData({ ...data, [taxName]: obj.id })
        }
        setTimeout(update, 150)
    }
    async function loadBranch() {
        let promisses = basicData()
        if (context.currentBranch) {
            if (context.currentBranch.is_fiscal) {
                setIsFical(true)
                promisses = [
                    ...promisses,
                    ...loadTaxes()
                ]
            }
        }

        const response = await Promise.all(promisses)

        setUnits(response[1])
        setCategories(response[2])

        if (promisses.length > 2) {
            const icms = response[3]
            const ipi = response[4]
            const pis = response[5]
            const cofins = response[6]
            const ibs_cbs = response[7] || []
            if (icms && ipi && pis && cofins) {
                setTaxes({
                    icms,
                    ipi,
                    pis,
                    cofins,
                    ibs_cbs
                })
            }
        }

        await new Promise(resolve => setTimeout(resolve, 500));

    }
    function onGetProductFromSearch(product) {
        const unit = units.filter(u => u.name.toLowerCase() === product.sellable.unit_branch.name.toLowerCase())[0].id

        const fiscal = {
            ncm: product.fiscal_data.ncm.id,
            cfop: product.fiscal_data.cfop.id,
            template_icms: product.fiscal_data.template_icms.id,
        }

        setData({
            ...data,
            name: product.sellable.name,
            price: product.sellable.price,
            cost: product.sellable.cost,
            unit,
            ncmCode: product.fiscal_data.ncm.code,
            ncmDescription: product.fiscal_data.ncm.description,
            cfopCode: product.fiscal_data.cfop.code,
            cfopDescription: product.fiscal_data.cfop.description,
            icms: product.fiscal_data.template_icms.id,
            fiscal,
        })
        setShowModalSearch(false)
    }
    function onRenderStockSectionRef() {
        const loadQueryString = () => {
            const path = window.location.href.split("?")
            if (path.length > 1) {
                const params = parseQueryString(path[1])
                if (params.action !== undefined) {
                    if (params.action === "manager-stock") {
                        try { document.getElementById("update-stock-item-quantity").click() } catch (error) { }
                    }
                }
            }
        }
        setTimeout(loadQueryString, 400)
    }
    React.useEffect(onRenderStockSectionRef, [stockSectionRef.current])

    async function getProductAndAdjustData(productId) {
        if (productId === false) {
            const maxCode = await getMaxCode()
            const _units = await getUnits()
            console.debug(_units)
            setData({
                ...data,
                ref_code: parseInt(maxCode.max_code) + 1,
                unit: _units[0].id
            })
            setN(parseInt(maxCode.max_code) + 1)
            setLoading(false)
            return false
        }
        const productData = await getProduct(productId)

        const newData = adaptProductData(productData)
        const Urlparams = new URLSearchParams(window.location.search);

        if (productData.fiscal_data) {
            const hasFiscalData = !!(
                (productData.fiscal_data.ncm && productData.fiscal_data.ncm.id) ||
                (productData.fiscal_data.cfop && productData.fiscal_data.cfop.id) ||
                (productData.fiscal_data.icms && productData.fiscal_data.icms.id)
            );
            setIsFical(hasFiscalData)

            if (Urlparams.size === 1) {
                delete newData.id
                const suggestion = Urlparams.get("suggestion");
                if (suggestion) {
                    const maxCode = await getMaxCode()
                    setN(parseInt(maxCode.max_code) + 1)
                    newData.ref_code = parseInt(maxCode.max_code) + 1
                }
            }
            setData(newData)
            setLoading(false)
        }
    }

    function init() {
        setLoading(true)

        loadBranch()

        window.scrollTo({ top: 0, behavior: "smooth" })

        const productId = parseIdFromProductPath()

        getProductAndAdjustData(productId)
    }
    React.useEffect(init, [context.currentBranch])

    const barcodeLen = (d) => {
        if (!d || d.barcode == null) return 0;
        return String(d.barcode).trim().length;
    };

    const hasIBSCBS = !!(data.fiscal && data.fiscal.template_ibs_cbs);
    const isIBSCBSVisible = showIBSCBS || hasIBSCBS;

    return <form onSubmit={onSave}>
        <Page title={`${data.id ? "Editar" : "Cadastrar"} item #${n}`}>
            <NoCertificateWarning />
            <Row>
                <Column col="12" hide={data.id}>
                    <ButtonImportCSV />
                </Column>

                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Código de Barras"
                        maxLength={20}
                        value={(data && data.barcode) || ''}
                        name="barcode"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />
                    <Button
                        type="button"
                        disabled={!(!loading && barcodeLen(data) >= 11)}
                        onClick={() => {
                            setLoading(true);
                            const code = (data && data.barcode) || '';

                            if (String(code).trim().length < 11) { setLoading(false); return; }

                            searchBarcode(code)
                                .then((response) => {
                                    onChange({ target: { name: "name", value: response.name } });
                                    setTimeout(() => {
                                        setData({ ...data, name: response.name });
                                    }, 700);
                                    setTimeout(() => {
                                        onChange({ target: { name: "fiscal:ncm", value: response.ncm } });
                                    }, 500);
                                })
                                .finally(() => {
                                    setTimeout(() => scrollTo({ top: 0, behavior: "smooth" }), 1000);
                                    setLoading(false);
                                });
                        }}
                    >
                        Buscar Código
                    </Button>

                </div>
                <div className="col-md-6 col-xs-12">
                    <_Input
                        label="Descrição do produto"
                        maxLength={120}
                        value={data.name}
                        name="name"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Código do produto"
                        maxLength={20}
                        value={data.ref_code}
                        name="ref_code"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />
                </div>
            </Row>
            <div className="row mt-2">
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Preço de venda"
                        type="currency"
                        maxLength={20}
                        value={data.price}
                        name="price"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { name: "price", value: e.value } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Preço de custo"
                        type="currency"
                        maxLength={20}
                        value={data.cost}
                        name="cost"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { name: "cost", value: e.value } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Unidade"
                        type="select"
                        maxLength={20}
                        value={data.unit}
                        name="unit"
                        disabled={loading}
                        options={units.filter(unit => unit.is_active !== false || unit.id == data.unit).map(unit => {
                            return {
                                label: unit.name,
                                value: unit.id
                            }
                        })}
                        onChange={e => {
                            onChange({ target: { name: "unit", value: e.value } })
                        }}
                    />
                    <CreateUnitOrCategory
                        existingItems={units}
                        onSave={unit => {
                            setUnits([
                                ...units,
                                unit
                            ])
                            setTimeout(() => {
                                onChange({ target: { name: "unit", value: unit.id } })
                            }, 250)
                        }}
                        name="Unidade" />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Categoria"
                        type="select"
                        maxLength={20}
                        value={data.category}
                        name="category"
                        disabled={loading}
                        options={categories.filter(category => category.is_active !== false || category.id == data.category).map(unit => {
                            return {
                                label: unit.name,
                                value: unit.id
                            }
                        })}
                        onChange={e => {
                            onChange({ target: { name: "category", value: e.value } })
                        }}
                    />
                    <CreateUnitOrCategory
                        existingItems={categories}
                        onSave={category => {
                            setCategories([
                                ...categories,
                                category
                            ])
                            setTimeout(() => {
                                onChange({ target: { name: "category", value: category.id } })
                            }, 250)
                        }}
                        name="Categoria" />
                </div>
            </div>

            {calculateProfitMargin(data.cost, data.price) < 10 && (
                <div className="row mb-2">
                    <div className="col-12" style={{ paddingLeft: '30px' }}>
                        <Text color={colors.red}>
                            Sua precificação está ruim, <a href="https://influen.cr/aula_markup_finep" target="_blank" rel="noreferrer">aprenda aqui a precificar para lucrar mais</a>
                        </Text>
                    </div>
                </div>
            )}

            <hr />
            <div className="row">
                <div className="col-12">
                    <Text className="py-3" as="h1">
                        Estoque
                    </Text>
                </div>
                <div className="col-md-3 col-xs-12" ref={stockSectionRef}>
                    {
                        data.id
                            ? <div>
                                <Text >
                                    Quantidade em estoque: {data.stock_quantity || 0}
                                </Text>
                                <UpdateStockQuantity
                                    name={data.name}
                                    onSave={() => {
                                        window.location.href = `/product/${data.id}`
                                    }}
                                    data={data} />
                            </div>
                            : <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Estoque inicial
                                    </Text>
                                </div>
                                <div className="">
                                    <CurrencyInput
                                        name="stock_quantity"
                                        value={data.stock_quantity}
                                        onChange={(a, b, c) => onChange({ target: { value: b, name: "stock_quantity" } })}
                                        thousandSeparator="."
                                        precision="0"
                                        className="form-control"
                                        disabled={loading} />
                                    <div className={`${data.id ? "d-block" : "d-none"}`}>
                                        <UpdateStockQuantity onSave={() => location.reload()} data={data} />
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
            <CheckBox onClick={value => {
                let fiscal = !isFiscal
                setIsFical(fiscal)
                updateBranchIsFiscal(fiscal)
            }} checked={isFiscal} label="Habilitar Códigos Fiscais" />
            <hr />
            <div className={`${isFiscal ? 'row' : 'd-none'}`} id="product-fiscal-codes">
                <div className="col-12">
                    <Text className="py-3" as="h1">
                        Códigos fiscais
                    </Text>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                NCM {data.ncmCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:ncm"
                            value={data.ncmCode}
                            placeholder='Pesquisar'
                            maxLength={8}
                            invalid={data.ncmCode && data.ncmCode.length === 8 && !loading && (!data.fiscal || !data.fiscal.ncm) && fiscalCodes.ncm.length === 0}
                            onChange={e => {
                                onChange({
                                    target: {
                                        name: "fiscal:ncm", value: e.target.value.replace(/\D+/g, "")
                                    }
                                })
                            }}
                            loading={loading}
                        />
                        {data.ncmCode && data.ncmCode.length === 8 && !loading && (!data.fiscal || !data.fiscal.ncm) && fiscalCodes.ncm.length === 0 && (
                            <div className="text-danger mt-1 my-4" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                                <i className="fa fa-exclamation-triangle mr-1 my-2"></i> Aviso: NCM não cadastrado. Fale com o suporte.
                            </div>
                        )}
                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.ncm.map((ncm, idx) => {
                                        let description = ncm.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => {
                                                setFicalCodes({
                                                    ...fiscalCodes,
                                                    ncm: []
                                                })
                                                const nd = { ...data }
                                                nd["ncmCode"] = ncm.code
                                                nd["ncmDescription"] = ncm.description
                                                setData(nd)

                                                if (nd["ncmCode"] >= 6) {
                                                    setLoading(true)
                                                    searchNCM({ code: nd["ncmCode"] })
                                                        .then(data => {
                                                            if (data.length === 0) {

                                                            } else if (data.length === 1) {
                                                                setFiscalCode("ncm", data[0])
                                                                setFicalCodes({
                                                                    ...fiscalCodes,
                                                                    ncm: []
                                                                })
                                                            } else {
                                                                setFicalCodes({
                                                                    ...fiscalCodes,
                                                                    ncm: data
                                                                })
                                                            }
                                                        })
                                                        .finally(() => {
                                                            setLoading(false)
                                                            try { document.querySelector('[name="fiscal:ncm"]').focus() } catch (error) { }
                                                        })
                                                }
                                            }}
                                            className="list-group-item"
                                            style={{ cursor: "pointer" }}>
                                            {ncm.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>
                        <a href='https://www.gov.br/receitafederal/pt-br/assuntos/aduana-e-comercio-exterior/classificacao-fiscal-de-mercadorias/ncm' target='_blank' className="mr-1">O que é?</a>
                        <a href='https://portalunico.siscomex.gov.br/classif/#/sumario?perfil=publico' target='_blank'>Encontrar NCM</a><br />
                        <span>
                            {data.ncmDescription}
                        </span>
                    </div>
                </div>
                <div className={`col-md-4 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                CEST {data.cestCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:cest"
                            value={data.cestCode}
                            placeholder='Pesquisar'
                            maxLength={7}
                            onChange={e => {
                                onChange({
                                    target: {
                                        name: "fiscal:cest", value: e.target.value.replace(/\D+/g, "")
                                    }
                                })
                            }}
                            loading={loading}
                        />
                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.cest.map((cest, idx) => {
                                        let description = cest.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => setFiscalCode("cest", cest)}
                                            style={{ cursor: "pointer" }}
                                            className="list-group-item" >
                                            {cest.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                CFOP {data.cfopCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:cfop"
                            value={data.cfopCode}
                            maxLength={5}
                            onChange={e => onChange({ target: { name: "fiscal:cfop", value: e.target.value.replace(/\D+/g, "") } })}
                            loading={loading}
                            className="mb-0" />
                        <span>
                            {data.cfopDescription}
                        </span>
                        {
                            CFOP_CODES_FUEL.includes(data.cfopCode) && <React.Fragment>
                                <Text className="my-2">
                                    Informações ANP - Agência Nacional de Petróleo
                                </Text>
                                <div className="form-label">
                                    <Text>
                                        Código de produto da ANP
                                    </Text>
                                </div>
                                <LoadingInput onChange={e => onChange({ target: { name: "fiscal:anp_code", value: e.target.value.replace(/\D+/g, "") } })} name="fiscal:anp_code" value={data.ANPCode} maxLength={9} />
                                <div className="form-label">
                                    <Text>
                                        Descrição do produto conforme ANP
                                    </Text>
                                </div>
                                <LoadingInput onChange={e => onChange({ target: { name: "fiscal:anp_description", value: e.target.value + "" } })} name="fiscal:anp_description" value={data.ANPDescription} maxLength={95} />
                            </React.Fragment>
                        }

                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.cfop.map((cfop, idx) => {
                                        let description = cfop.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => setFiscalCode("cfop", cfop)}
                                            style={{ cursor: "pointer" }}
                                            className="list-group-item" >
                                            {cfop.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>

                        <div className="d-flex">

                            <Text style={{ cursor: 'pointer' }} onClick={() => {
                                setLoading(true)
                                searchCFOP({ code: 5102 })
                                    .then(resp => {
                                        setFiscalCode("cfop", resp[0])
                                    }).finally(() => {
                                        setLoading(false)
                                    })
                            }}>
                                Sugestão: 5102
                            </Text>
                            {/* <div className="d-flex justify-content-around"> */}
                            {/* <SimpleButton onClick={() => {
                                setLoading(true)
                                searchCFOP({code: 5101})
                                .then(resp =>{
                                    setFiscalCode("cfop", resp[0])
                                }).finally(()=>{
                                    setLoading(false)
                                })
                            }}>
                                5101
                                </SimpleButton> */}
                            {/* <SimpleButton onClick={() => {
                                setLoading(true)
                                searchCFOP({ code: 5102 })
                                    .then(resp => {
                                        setFiscalCode("cfop", resp[0])
                                    }).finally(() => {
                                        setLoading(false)
                                    })
                            }}>
                                5102
                            </SimpleButton> */}
                        </div>
                        {/* </div> */}
                    </div>

                </div>

                <hr />
            </div>

            <div className={`${isFiscal ? 'row' : 'd-none'}`} id="product-fiscal-taxes">
                <div className="col-12 d-flex align-items-center ">
                    <Text className=" py-3" as="h1">
                        Impostos
                    </Text>

                    <div className="ml-3">
                        <Form.Check
                            className=""
                            type="switch"
                            id="toggle"
                            label={isToggled ? <Text className="form-label" >Simplificado</Text> : <Text className="form-label" >Estendido</Text>}

                            checked={isToggled}
                            onChange={handleToggle}
                        />
                    </div>

                </div>

                <div className="col-md-3 col-xs-12">

                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                ICMS
                            </Text>
                        </div>
                        <div className="d-flex align-items-center">
                            <FormControl
                                name="fiscal:template_icms"
                                onChange={onChange}
                                disabled={loading}
                                className="flex-grow-1"
                                value={(data.fiscal && data.fiscal.template_icms) || ""}
                                as="select">
                                <option value="" disabled>Selecione</option>
                                {
                                    taxes.icms.map((icms, idx) => {
                                        return <option
                                            key={`icms-template-list-${icms.id}${idx}`}
                                            value={icms.id}>{icms.name}</option>
                                    })
                                }
                            </FormControl>
                            {!isIBSCBSVisible && (
                                <Button
                                    type="button"
                                    className="ml-2 btn-sm"
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() => setShowIBSCBS(true)}
                                >
                                    IBS/CBS
                                </Button>
                            )}
                        </div>
                        {showIcmsAlert && (
                            <div className="text-danger mt-2" style={{ fontSize: "0.85rem", fontWeight: "bold" }}>
                                <i className="fa fa-exclamation-triangle mr-1"></i> Selecione um modelo de ICMS ou clique em "Criar novo modelo" para continuar.
                            </div>
                        )}
                        <CreateICMS
                            onClear={true}
                            data={{}}
                            onSave={obj => onSaveNewTemplate(obj, "icms")} />
                    </div>
                </div>

                {isIBSCBSVisible && (
                <div className="col-md-3 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>IBS/CBS</Text>
                        </div>
                        <FormControl
                            name="fiscal:template_ibs_cbs"
                            onChange={e => {
                                onChange(e);
                                if (!e.target.value) {
                                    setShowIBSCBS(false);
                                }
                            }}
                            disabled={loading}
                            value={(data.fiscal && data.fiscal.template_ibs_cbs) || ""}
                            as="select">
                            <option value="">Não informar</option>
                            {
                                (taxes.ibs_cbs || []).map((ibscbs, idx) => {
                                    return <option
                                        key={`ibscbs-template-list-${ibscbs.id}${idx}`}
                                        value={ibscbs.id}>{ibscbs.name}</option>
                                })
                            }
                        </FormControl>
                        <CreateIBSCBS
                            onClear={true}
                            data={{}}
                            buttonText="cadastrar modelo de IBS e CBS"
                            onSave={obj => onSaveNewTemplate(obj, "ibs_cbs")} />
                    </div>
                </div>
                )}
                
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                IPI
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_ipi"
                            onChange={onChange}
                            disabled={loading}
                            as="select">
                            <option value="" selected>Selecione o IPI</option>
                            {
                                taxes.ipi.map((ipi, idx) => {
                                    return <option
                                        selected={data.ipi === ipi.id}
                                        key={`ipi-template-list-${ipi.id}${idx}`}
                                        value={ipi.id}>{ipi.name}</option>
                                })
                            }
                        </FormControl>
                        <CreateIPI
                            data={taxes.ipi}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "ipi")} />
                    </div>
                </div>
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                PIS
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_pis"
                            disabled={loading}
                            onChange={onChange}
                            as="select">
                            <option value="" selected >Selecione</option>
                            {
                                taxes.pis.map((pis, idx) => {
                                    return <option
                                        selected={data.pis === pis.id}
                                        key={`pis-template-list-${pis.id}${idx}`}
                                        value={pis.id}>{pis.name}</option>
                                })
                            }
                        </FormControl>
                        <CreatePIS
                            data={taxes.pis}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "pis")} />
                    </div>
                </div>
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                COFINS
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_cofins"
                            onChange={onChange}
                            disabled={loading}
                            as="select">
                            <option value="" selected>Selecione</option>
                            {
                                taxes.cofins.map((cofins, idx) => {
                                    return <option
                                        selected={data.cofins === cofins.id}
                                        key={`cofins-template-list-${cofins.id}${idx}`}
                                        value={cofins.id}>{cofins.name}</option>
                                })
                            }
                        </FormControl>
                        <CreateCOFINS
                            data={taxes.cofins}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "cofins")} />
                    </div>
                </div>
            </div>

            <hr />
            <div className="row">
                <div className="col-12">
                    <Text>
                        Anotações/Observações
                    </Text>
                </div>
                <div className="col-md-7 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <LoadingInput
                                name="notes"
                                loading={loading}
                                onChange={onChange}
                                value={data.notes}
                                maxLength={200}
                                as="textarea" />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="d-flex justify-content-center  py-3 ">
                <Button
                    disabled={loading}
                    // type="submit"
                    className="px-5"
                    onClick={onSave}>
                    Salvar
                </Button>
            </div>
            <div
                style={{ cursor: 'pointer' }}
                className="d-flex justify-content-center my-3 ">
                <Text
                    onClick={() => {
                        location.href = "/products"
                    }}
                    className="text-danger"
                >
                    Cancelar
                </Text>
            </div>
            {
                data.id
                    ? <div className="d-flex justify-content-end my-3">
                        <Text onClick={() => {
                            deactivate(data.id).then()
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            const redirect = () => window.location.href = `/products/`
                            toast.success("Produto desativado com sucesso!", { position: "top-center" })
                            setTimeout(redirect, 3000)
                        }}
                            style={{ cursor: 'pointer' }}
                            className="text-danger">
                            Desativar produto
                        </Text>
                    </div>
                    : <React.Fragment />
            }
        </Page>
        <Modal title="Pesquisa item" onHide={() => setShowModalSearch(false)} show={showModalSearch}>
            <FilterProducts onClick={onGetProductFromSearch} />
        </Modal>
    </form>
}


///// ================================================================================================================
export function CreateProductContainer(props) {
    const context = React.useContext(AppContext)

    const stockSectionRef = React.useRef(null)

    const [loading, setLoading] = React.useState(true)
    const [n, setN] = React.useState(0)
    const [isFiscal, setIsFical] = React.useState(false)
    const [data, setData] = React.useState({ barcode: "" })
    const [units, setUnits] = React.useState([])
    const [categories, setCategories] = React.useState([])
    const [taxes, setTaxes] = React.useState({ icms: [], ipi: [], pis: [], cofins: [] })
    const [fiscalCodes, setFicalCodes] = React.useState({ ncm: [], cfop: [], cest: [] })
    const [showModal, setShowModal] = React.useState(false)
    const [passedCaptcha, setPassedCaptcha] = React.useState(true)
    const [isToggled, setIsToggled] = React.useState(true);
    const [showModalSearch, setShowModalSearch] = React.useState(false)
    const [showIcmsAlert, setShowIcmsAlert] = React.useState(false) // eslint-disable-line no-unused-vars

    const parseIdFromProductPath = useInitData()
    const adaptProductData = useProductData()

    function handleToggle() {
        setIsToggled(!isToggled)
    }
    function containsUnicodeCharacter(input) {
        for (let i = 0; i < input.length; i++) {

            if (input.charCodeAt(i) > 127 && !/[a-zA-Zçáéíóúâêôãõ]/.test(input[i])) {
                return true;
            }
        }
        return false;
    }
    function onChange({ target }) {
        const { name: key, value } = target
        if (key === "ref_code") {
            validateRefCode(value)
        }

        if (key.includes(":")) {
            const [father, child] = key.split(":")
            setData(prev => {
                const isSearchField = ["ncm", "cfop", "cest"].includes(child);
                return {
                    ...prev,
                    fiscal: {
                        ...prev.fiscal,
                        [child]: isSearchField ? null : (value === "" ? null : value)
                    }
                }
            })
            if (key === "fiscal:template_icms" && value) {
                setShowIcmsAlert(false)
                try {
                    document.querySelector(`[name="fiscal:template_icms"]`).classList.remove("is-invalid")
                } catch (error) { }
            }
        } else {
            setData(prev => ({
                ...prev,
                [key]: value
            }))
        }
        if (key === "ref_code") {
            if (containsUnicodeCharacter(value)) {
                setData(prev => ({
                    ...prev,
                    ref_code: "",
                }))
            } else {
                setData(prev => ({
                    ...prev,
                    ref_code: value,
                }))
            }
        }
        if (key === "name") {
            setData(prev => ({
                ...prev,
                name: value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[<>~`´^°\\|]/g, '')
            }))
        }
        if (key === "fiscal:ncm") {
            setData(prev => ({
                ...prev,
                ncmCode: value
            }))
            if (value.length >= 6) {
                setLoading(true)
                searchNCM({ code: value })
                    .then(data => {
                        if (data.length === 0) {

                        } else if (data.length === 1) {
                            setFiscalCode("ncm", data[0])
                            setFicalCodes(prev => ({
                                ...prev,
                                ncm: []
                            }))
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                ncm: data
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:ncm"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "fiscal:cfop") {
            setData(prev => ({
                ...prev,
                cfopCode: value
            }))
            if (value.length === 4) {
                setLoading(true)
                searchCFOP({ code: value })
                    .then(cfop => {
                        if (cfop.length === 0) {

                        } else if (cfop.length === 1) {
                            setFiscalCode("cfop", cfop[0])
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                cfop
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:cfop"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "fiscal:cest") {
            setData(prev => ({
                ...prev,
                cestCode: value
            }))
            if (value.length >= 3) {
                setLoading(true)
                searchCEST({ code: value })
                    .then(data => {
                        if (data.length === 0) {
                        } else if (data.length === 1) {
                            setFiscalCode("cest", data[0])
                            setFicalCodes(prev => ({
                                ...prev,
                                cest: []
                            }))
                        } else {
                            setFicalCodes(prev => ({
                                ...prev,
                                cest: data
                            }))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        try { document.querySelector('[name="fiscal:cest"]').focus() } catch (error) { }
                    })
            }
        } else if (key === "stock_quantity") {
            setData(prev => {
                let { stock } = prev
                if (stock === undefined) {
                    stock = {
                        quantity: value
                    }
                } else {
                    stock.quantity = value
                }
                return {
                    ...prev,
                    stock
                }
            })
        }


    }
    function validateRefCode(value) {
        setLoading(true);
        validateProductRefCode(value)
            .then(() => {
                try {
                    const input = document.querySelector("[name=ref_code]");
                    input.focus();
                    input.classList.remove("is-invalid");
                } catch (error) { }
            })
            .catch((err) => {
                try {
                    const input = document.querySelector("[name=ref_code]");
                    input.focus();
                    input.classList.add("is-invalid");
                } catch (error) { }
            })
            .finally(() => {
                setLoading(false);
                try {
                    document.querySelector("[name=ref_code]").focus();
                } catch (error) { }
            });
    }
    function setFiscalCode(code, obj) {
        setData(prev => ({
            ...prev,
            [`${code}Code`]: obj.code,
            [`${code}Description`]: obj.description,
            fiscal: {
                ...prev.fiscal || {},
                [code]: obj.id
            }
        }))
        setFicalCodes(prev => ({
            ...prev,
            ncm: [],
            cfop: [],
            cest: []
        }))
        if (code === "template_icms") {
            setShowIcmsAlert(false)
            try {
                document.querySelector(`[name="fiscal:template_icms"]`).classList.remove("is-invalid")
            } catch (error) { }
        }
    }
    function setDefaulCFOP(code) {
        searchCFOP({ code })
            .then(cfop => {
                if (cfop.length === 0) {

                } else if (cfop.length === 1) {
                    setFiscalCode("cfop", cfop[0])
                } else {
                    setFicalCodes({
                        ...fiscalCodes,
                        cfop
                    })
                }
            })
            .finally(() => {
                setLoading(false)
                try { document.querySelector('[name="fiscal:cfop"]').focus() } catch (error) { }
            })
        //setFiscalCode("cfop", d[code])
    }
    function basicData() {
        return [getMaxCode().then(), getUnits().then(), getCategories().then()]
    }
    function loadTaxes() {
        return [getICMSList().then(), getIPI().then(), getPIS(), getCOFINS().then()]
    }
    function onSave(e) {
        e.preventDefault()


        let isValid = true

        let fields = ['name', 'price', 'unit', 'ref_code']
        let fiscalFields = ["fiscal:ncm", "fiscal:cfop", "fiscal:template_icms"]

        if (isFiscal) {
            fields = fields.concat(fiscalFields)

            if (data.ncmCode && (!data.fiscal || !data.fiscal.ncm)) {
                toast.warn(<Text color="white">O NCM informado ({data.ncmCode}) não está cadastrado na base de dados.</Text>, {
                    position: "top-center",
                    toastId: "error-ncm-not-found"
                })
                isValid = false
            } else if (!data.fiscal || !data.fiscal.ncm) {
                toast.warn(<Text color="white">Por favor, pesquise e selecione um NCM válido.</Text>, {
                    position: "top-center",
                    toastId: "error-ncm-required"
                })
                isValid = false
            }
        }

        for (let field of fields) {
            const toggleClass = act => {
                try {
                    document.querySelector(`[name="${field}"]`).classList[act]("is-invalid")
                } catch (error) { }
            }
            if (field.includes(":")) {
                const [father, child] = field.split(":")
                if (!data[father]) {
                    toggleClass("add")
                    isValid = false
                    if (field === "fiscal:template_icms") {
                        setShowIcmsAlert(true)
                    }
                } else {
                    if (!data[father][child]) {
                        toggleClass("add")
                        isValid = false
                        if (field === "fiscal:template_icms") {
                            setShowIcmsAlert(true)
                        }
                    } else {
                        toggleClass("remove")
                        if (field === "fiscal:template_icms") {
                            setShowIcmsAlert(false)
                        }
                    }
                }
            } else if (!data[field]) {
                toggleClass("add")
                isValid = false
            } else {
                toggleClass("remove")
            }
        }
        if (!isValid) {
            window.scrollTo({ top: 0, behavior: "smooth" })
            return
        }
        if (document.querySelectorAll(".is-invalid").length > 0) {
            window.scrollTo({ top: 0, behavior: "smooth" })
            return
        }
        if (data.stock) {
            data.stock.quantity = data.stock_quantity
        }
        if (data.fiscal) {
            if (data.ANPCode && data.ANPDescription) {
                data.fiscal.anp_code = data.ANPCode
                data.fiscal.anp_description = data.ANPDescription
            }
            if (!data.cestCode) {
                data.fiscal.cest = null
            }
        }
        setLoading(true)
        const request = data.id ? updateProduct : createProduct
        request(data)
            .then(data => {
                toast.success("Produto salvo com sucesso!", { position: "top-center" })
                if (props.onSave) {
                    setLoading(false)

                    setData({ barcode: "" })
                    props.onSave(data)
                    setTimeout(() => {
                        props.closeIt()
                    }, 3000);
                } else {
                    setTimeout(() => {
                        props.closeIt()
                    }, 3000);
                    window.scrollTo({ top: 0, behavior: "smooth" })
                }
            })
            .catch(error => {
                if (error.ref_code_already_exists) {
                    validateRefCode(data.ref_code)
                }
                setLoading(false)
            })
    }
    function onSaveNewTemplate(obj, taxName) {
        const tax = taxes[taxName]
        tax.push(obj)
        setTaxes({ ...taxes, [taxName]: [] })
        const update = () => {
            setTaxes({ ...taxes, [taxName]: tax })
            setFiscalCode(`template_${taxName}`, obj)
            setData({ ...data, [taxName]: obj.id })
        }
        setTimeout(update, 150)
    }
    function loadBranch() {
        let promisses = basicData()
        if (context.currentBranch) {
            if (context.currentBranch.is_fiscal) {
                setIsFical(true)
                promisses = [
                    ...promisses,
                    ...loadTaxes()
                ]
            }
        }
        Promise.all(promisses)
            .then(response => {
                if (window.location.pathname.split("product/").length === 1) {

                    setData({
                        ref_code: parseInt(response[0].max_code || 0) + 1,
                        unit: response[1][0].id
                    })
                    setN(parseInt(response[0].max_code || 0) + 1)
                }
                setUnits(response[1])
                setCategories(response[2])
                if (promisses.length > 2) {
                    const icms = response[3]
                    const ipi = response[4]
                    const pis = response[5]
                    const cofins = response[6]
                    if (icms && ipi && pis && cofins) {
                        setTaxes({
                            icms,
                            ipi,
                            pis,
                            cofins
                        })
                    }
                }

            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                }, 400)
            })
    }
    function onGetProductFromSearch(product) {
        const unit = units.filter(u => u.name.toLowerCase() === product.sellable.unit_branch.name.toLowerCase())[0].id

        const fiscal = {
            ncm: product.fiscal_data.ncm.id,
            cfop: product.fiscal_data.cfop.id,
            template_icms: product.fiscal_data.template_icms.id,
        }

        setData({
            ...data,
            name: product.sellable.name,
            price: product.sellable.price,
            cost: product.sellable.cost,
            unit,
            ncmCode: product.fiscal_data.ncm.code,
            ncmDescription: product.fiscal_data.ncm.description,
            cfopCode: product.fiscal_data.cfop.code,
            cfopDescription: product.fiscal_data.cfop.description,
            icms: product.fiscal_data.template_icms.id,
            fiscal,
        })
        setShowModalSearch(false)
    }
    function onRenderStockSectionRef() {
        const loadQueryString = () => {
            const path = window.location.href.split("?")
            if (path.length > 1) {
                const params = parseQueryString(path[1])
                if (params.action !== undefined) {
                    if (params.action === "manager-stock") {
                        try { document.getElementById("update-stock-item-quantity").click() } catch (error) { }
                    }
                }
            }
        }
        setTimeout(loadQueryString, 400)
    }

    React.useEffect(onRenderStockSectionRef, [stockSectionRef.current])

    function init() {
        setLoading(true)
        window.scrollTo({ top: 0, behavior: "smooth" })

        const params = parseIdFromProductPath()

        if (params) {
            getProduct(params)
                .then(product => {
                    console.debug(product)
                    const newData = adaptProductData(product)
                    if (!params) {
                        delete newData.id
                        getMaxCode().then(response => {
                            newData.ref_code = parseInt(response.max_code || 0) + 1
                            validateRefCode(newData.ref_code)
                        })
                    }
                    setN(newData.ref_code)
                    setData(newData)
                })
                .finally(() => {
                    loadBranch()
                })
        } else {
            loadBranch()
        }
    }

    const barcodeLen = (d) => {
        if (!d || d.barcode == null) return 0;
        return String(d.barcode).trim().length;
    };

    React.useEffect(init, [context.currentBranch])

    return <form onSubmit={onSave} ref={null}>
        <Page title={`${data.id ? "Editar" : "Cadastrar"} item #${n}`}>
            <Row>
                <Column col="12" hide={data.id}>
                    <ButtonImportCSV />
                </Column>

                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Código de Barras"
                        maxLength={20}
                        value={(data && data.barcode) || ''}
                        name="barcode"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />

                    <Button
                        type="button"
                        disabled={!(!loading && barcodeLen(data) >= 11)}
                        onClick={() => {
                            setLoading(true);
                            const code = (data && data.barcode) || '';

                            if (String(code).trim().length < 11) { setLoading(false); return; }

                            searchBarcode(code)
                                .then((response) => {
                                    onChange({ target: { name: "name", value: response.name } });
                                    setTimeout(() => {
                                        setData({ ...data, name: response.name });
                                    }, 700);
                                    setTimeout(() => {
                                        onChange({ target: { name: "fiscal:ncm", value: response.ncm } });
                                    }, 500);
                                })
                                .finally(() => {
                                    setTimeout(() => scrollTo({ top: 0, behavior: "smooth" }), 1000);
                                    setLoading(false);
                                });
                        }}
                    >
                        Buscar Código
                    </Button>

                </div>
                <div className="col-md-6 col-xs-12">
                    <_Input
                        label="Descrição do produto"
                        maxLength={120}
                        value={data.name}
                        name="name"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Código do produto"
                        maxLength={20}
                        value={data.ref_code}
                        name="ref_code"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { ...e } })
                        }}
                    />
                </div>
            </Row>
            <div className="row mt-2">
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Preço de venda"
                        type="currency"
                        maxLength={20}
                        value={data.price}
                        name="price"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { name: "price", value: e.value } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Preço de custo"
                        type="currency"
                        maxLength={20}
                        value={data.cost}
                        name="cost"
                        disabled={loading}
                        onChange={e => {
                            onChange({ target: { name: "cost", value: e.value } })
                        }}
                    />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Unidade"
                        type="select"
                        maxLength={20}
                        value={data.unit}
                        name="unit"
                        disabled={loading}
                        options={units.filter(unit => unit.is_active !== false || unit.id == data.unit).map(unit => {
                            return {
                                label: unit.name,
                                value: unit.id
                            }
                        })}
                        onChange={e => {
                            onChange({ target: { name: "unit", value: e.value } })
                        }}
                    />
                    <CreateUnitOrCategory
                        existingItems={units}
                        onSave={unit => {
                            setUnits([
                                ...units,
                                unit
                            ])
                            setTimeout(() => {
                                onChange({ target: { name: "unit", value: unit.id } })
                            }, 250)
                        }}
                        name="Unidade" />
                </div>
                <div className="col-md-3 col-xs-12">
                    <_Input
                        label="Categoria"
                        type="select"
                        maxLength={20}
                        value={data.category}
                        name="category"
                        disabled={loading}
                        options={categories.filter(category => category.is_active !== false || category.id == data.category).map(category => {
                            return {
                                label: category.name,
                                value: category.id
                            }
                        })}
                        onChange={e => {
                            onChange({ target: { name: "category", value: e.value } })
                        }}
                    />
                    <CreateUnitOrCategory
                        existingItems={categories}
                        onSave={category => {
                            setCategories([
                                ...categories,
                                category
                            ])
                            setTimeout(() => {
                                onChange({ target: { name: "category", value: category.id } })
                            }, 250)
                        }}
                        name="Categoria" />
                </div>
            </div>

            <hr />
            <div className="row">
                <div className="col-12">
                    <Text className="py-3" as="h1">
                        Estoque
                    </Text>
                </div>
                <div className="col-md-3 col-xs-12" ref={stockSectionRef}>
                    {
                        data.id
                            ? <div>
                                <Text >
                                    Quantidade em estoque: {data.stock_quantity || 0}
                                </Text>
                                <UpdateStockQuantity
                                    name={data.name}
                                    onSave={() => {
                                        window.location.href = `/product/${data.id}`
                                    }}
                                    data={data} />
                            </div>
                            : <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Estoque inicial
                                    </Text>
                                </div>
                                <div className="">
                                    <CurrencyInput
                                        name="stock_quantity"
                                        value={data.stock_quantity}
                                        onChange={(a, b, c) => onChange({ target: { value: b, name: "stock_quantity" } })}
                                        thousandSeparator="."
                                        precision="0"
                                        className="form-control"
                                        disabled={loading} />
                                    <div className={`${data.id ? "d-block" : "d-none"}`}>
                                        <UpdateStockQuantity onSave={() => location.reload()} data={data} />
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
            <hr />
            <div className={`${isFiscal ? 'row' : 'd-none'}`} id="product-fiscal-codes">
                <div className="col-12">
                    <Text className="py-3" as="h1">
                        Códigos fiscais
                    </Text>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                NCM {data.ncmCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:ncm"
                            value={data.ncmCode}
                            placeholder='Pesquisar'
                            maxLength={8}
                            invalid={data.ncmCode && data.ncmCode.length === 8 && !loading && (!data.fiscal || !data.fiscal.ncm) && fiscalCodes.ncm.length === 0}
                            onChange={e => {
                                onChange({
                                    target: {
                                        name: "fiscal:ncm", value: e.target.value.replace(/\D+/g, "")
                                    }
                                })
                            }}
                            loading={loading}
                        />
                        {data.ncmCode && data.ncmCode.length === 8 && !loading && (!data.fiscal || !data.fiscal.ncm) && fiscalCodes.ncm.length === 0 && (
                            <div className="text-danger mt-1 my-4" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                                <i className="fa fa-exclamation-triangle mr-1 my-2"></i> Aviso: NCM não cadastrado. Fale com o suporte.
                            </div>
                        )}
                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.ncm.map((ncm, idx) => {
                                        let description = ncm.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => {
                                                setFicalCodes({
                                                    ...fiscalCodes,
                                                    ncm: []
                                                })
                                                const nd = { ...data }
                                                nd["ncmCode"] = ncm.code
                                                nd["ncmDescription"] = ncm.description
                                                setData(nd)

                                                if (nd["ncmCode"] >= 6) {
                                                    setLoading(true)
                                                    searchNCM({ code: nd["ncmCode"] })
                                                        .then(data => {
                                                            if (data.length === 0) {

                                                            } else if (data.length === 1) {
                                                                setFiscalCode("ncm", data[0])
                                                                setFicalCodes({
                                                                    ...fiscalCodes,
                                                                    ncm: []
                                                                })
                                                            } else {
                                                                setFicalCodes({
                                                                    ...fiscalCodes,
                                                                    ncm: data
                                                                })
                                                            }
                                                        })
                                                        .finally(() => {
                                                            setLoading(false)
                                                            try { document.querySelector('[name="fiscal:ncm"]').focus() } catch (error) { }
                                                        })
                                                }
                                            }}
                                            className="list-group-item"
                                            style={{ cursor: "pointer" }}>
                                            {ncm.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>
                        <a href='https://www.gov.br/receitafederal/pt-br/assuntos/aduana-e-comercio-exterior/classificacao-fiscal-de-mercadorias/ncm' target='_blank' className="mr-1">O que é?</a>
                        <a href='https://portalunico.siscomex.gov.br/classif/#/sumario?perfil=publico' target='_blank'>Encontrar NCM</a><br />
                        <span>
                            {data.ncmDescription}
                        </span>
                    </div>
                </div>
                <div className={`col-md-4 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                CEST {data.cestCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:cest"
                            value={data.cestCode}
                            placeholder='Pesquisar'
                            maxLength={7}
                            onChange={e => {
                                onChange({
                                    target: {
                                        name: "fiscal:cest", value: e.target.value.replace(/\D+/g, "")
                                    }
                                })
                            }}
                            loading={loading}
                        />
                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.cest.map((cest, idx) => {
                                        let description = cest.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => setFiscalCode("cest", cest)}
                                            style={{ cursor: "pointer" }}
                                            className="list-group-item" >
                                            {cest.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                CFOP {data.cfopCode}
                            </Text>
                        </div>
                        <LoadingInput
                            name="fiscal:cfop"
                            value={data.cfopCode}
                            maxLength={5}
                            onChange={e => onChange({ target: { name: "fiscal:cfop", value: e.target.value.replace(/\D+/g, "") } })}
                            loading={loading}
                            className="mb-0" />

                        <ScrollableContainer className="">
                            <ul className="list-group">
                                {
                                    fiscalCodes.cfop.map((cfop, idx) => {
                                        let description = cfop.description
                                        if (description.length > 80) {
                                            description = `${description.substring(0, 80)}...`
                                        }
                                        return <li
                                            onClick={() => setFiscalCode("cfop", cfop)}
                                            style={{ cursor: "pointer" }}
                                            className="list-group-item" >
                                            {cfop.code} - {description}
                                        </li>
                                    })
                                }
                            </ul>
                        </ScrollableContainer>
                        <span>
                            {data.cfopDescription}
                        </span>

                        <div className="d-flex">

                            <Text style={{ cursor: 'pointer' }} onClick={() => {
                                setLoading(true)
                                searchCFOP({ code: 5102 })
                                    .then(resp => {
                                        setFiscalCode("cfop", resp[0])
                                    }).finally(() => {
                                        setLoading(false)
                                    })
                            }}>
                                Sugestão: 5102
                            </Text>
                            {/* <div className="d-flex justify-content-around"> */}
                            {/* <SimpleButton onClick={() => {
                                setLoading(true)
                                searchCFOP({code: 5101})
                                .then(resp =>{
                                    setFiscalCode("cfop", resp[0])
                                }).finally(()=>{
                                    setLoading(false)
                                })
                            }}>
                                5101
                                </SimpleButton> */}
                            {/* <SimpleButton onClick={() => {
                                setLoading(true)
                                searchCFOP({ code: 5102 })
                                    .then(resp => {
                                        setFiscalCode("cfop", resp[0])
                                    }).finally(() => {
                                        setLoading(false)
                                    })
                            }}>
                                5102
                            </SimpleButton> */}
                        </div>

                    </div>

                </div>

                <hr />
            </div>

            <div className={`${isFiscal ? 'row' : 'd-none'}`} id="product-fiscal-taxes">
                <div className="col-12 d-flex align-items-center ">
                    <Text className=" py-3" as="h1">
                        Impostos
                    </Text>

                    <div className="ml-3">
                        <Form.Check
                            className=""
                            type="switch"
                            id="toggle"
                            label={isToggled ? <Text className="form-label" >Simplificado</Text> : <Text className="form-label" >Estendido</Text>}

                            checked={isToggled}
                            onChange={handleToggle}
                        />
                    </div>

                </div>

                <div className="col-md-3 col-xs-12">

                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                ICMS
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_icms"
                            onChange={onChange}
                            disabled={loading}
                            as="select">
                            <option value="" selected disabled>Selecione</option>
                            {
                                taxes.icms.map((icms, idx) => {
                                    return <option
                                        selected={data.icms === icms.id}
                                        key={`icms-template-list-${icms.id}${idx}`}
                                        value={icms.id}>{icms.name}</option>
                                })
                            }
                        </FormControl>
                        {showIcmsAlert && (
                            <div className="text-danger mt-2" style={{ fontSize: "0.85rem", fontWeight: "bold" }}>
                                <i className="fa fa-exclamation-triangle mr-1"></i> Selecione um modelo de ICMS ou clique em "Criar novo modelo" para continuar.
                            </div>
                        )}
                        <CreateICMS
                            onClear={true}
                            data={{}}
                            onSave={obj => onSaveNewTemplate(obj, "icms")} />
                    </div>
                </div>
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                IPI
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_ipi"
                            onChange={onChange}
                            disabled={loading}
                            as="select">
                            <option value="" selected>Selecione o IPI</option>
                            {
                                taxes.ipi.map((ipi, idx) => {
                                    return <option
                                        selected={data.ipi === ipi.id}
                                        key={`ipi-template-list-${ipi.id}${idx}`}
                                        value={ipi.id}>{ipi.name}</option>
                                })
                            }
                        </FormControl>
                        <CreateIPI
                            data={taxes.ipi}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "ipi")} />
                    </div>
                </div>
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                PIS
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_pis"
                            disabled={loading}
                            onChange={onChange}
                            as="select">
                            <option value="" selected >Selecione</option>
                            {
                                taxes.pis.map((pis, idx) => {
                                    return <option
                                        selected={data.pis === pis.id}
                                        key={`pis-template-list-${pis.id}${idx}`}
                                        value={pis.id}>{pis.name}</option>
                                })
                            }
                        </FormControl>
                        <CreatePIS
                            data={taxes.pis}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "pis")} />
                    </div>
                </div>
                <div className={`col-md-3 col-xs-12 ${isToggled ? 'd-none' : ''}`}>
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                COFINS
                            </Text>
                        </div>
                        <FormControl
                            name="fiscal:template_cofins"
                            onChange={onChange}
                            disabled={loading}
                            as="select">
                            <option value="" selected>Selecione</option>
                            {
                                taxes.cofins.map((cofins, idx) => {
                                    return <option
                                        selected={data.cofins === cofins.id}
                                        key={`cofins-template-list-${cofins.id}${idx}`}
                                        value={cofins.id}>{cofins.name}</option>
                                })
                            }
                        </FormControl>
                        <CreateCOFINS
                            data={taxes.cofins}
                            textButton
                            onSave={obj => onSaveNewTemplate(obj, "cofins")} />
                    </div>
                </div>
            </div>

            <hr />
            <div className="row">
                <div className="col-12">
                    <Text>
                        Anotações/Observações
                    </Text>
                </div>
                <div className="col-md-7 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <LoadingInput
                                name="notes"
                                loading={loading}
                                onChange={onChange}
                                value={data.notes}
                                maxLength={200}
                                as="textarea" />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="d-flex justify-content-center  py-3 ">
                <Button
                    disabled={loading}
                    // type="submit"
                    className="px-5"
                    onClick={onSave}>
                    Salvar
                </Button>
            </div>
            <div
                style={{ cursor: 'pointer' }}
                className="d-flex justify-content-center my-3 ">
                <Text
                    onClick={() => {
                        props.closeIt()
                    }}
                    className="text-danger"
                >
                    Cancelar
                </Text>
            </div>
        </Page>
        <Modal title="Pesquisa item" onHide={() => setShowModalSearch(false)} show={showModalSearch}>
            <FilterProducts onClick={onGetProductFromSearch} modalBehavior />
        </Modal>
    </form>
}
///// ================================================================================================================


function CreateUnitOrCategory(props) {
    const [show, setShow] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [name, setName] = React.useState('')

    function onHide() {
        if (loading) {
            return
        }
        setShow(false)
        setName("")
    }
    function onSave() {
        if (!name.trim()) return

        if (props.existingItems) {
            const exists = props.existingItems.find(item => item.name.toLowerCase() === name.trim().toLowerCase())
            if (exists) {
                toast.warn(`Já existe uma ${props.name.toLowerCase()} com esse nome!`, { position: "top-center" })
                return
            }
        }

        let request = props.name.toLowerCase() === "unidade" ? createUnit : createCategory
        if (props.name === "Categoria") {
            request = createCategory
        }
        setLoading(true)
        request({ name: name.trim() })
            .then(obj => {
                setShow(false)
                setName("")
                props.onSave(obj)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    return <React.Fragment>
        <Button type="button" disabled={loading} onClick={() => setShow(true)}>
            Criar {props.name}
        </Button>
        <Modal title={`Criar ${props.name}`} show={show} onHide={onHide}>
            <div className="form-group">
                <div className="form-label">
                    <Text>
                        Nome
                    </Text>
                </div>
                <FormControl maxLength={200} autoFocus value={name} onChange={e => setName(e.target.value)} />
                <div className="my-3 d-flex justify-content-end">
                    <Button onClick={onSave}>
                        Criar {props.name}
                    </Button>
                </div>
            </div>
        </Modal>
    </React.Fragment>
}
export function UpdateStockQuantity(props) {
    const [data, setData] = React.useState({})
    const [show, setShow] = React.useState(false)
    const [loading, setLoading] = React.useState(false)

    function onHide() {
        setShow(false)
    }

    function onChange(e) {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }
    function onSave() {
        setLoading(true)
        updateProductStock({
            ...data,
            stock_history: {
                reason: data.reason,
                type: data.type
            }
        }).then(() => {
            toast.success("Estoque atualizado", { position: "top-center" })
            setTimeout(() => {
                props.onSave()
            }, 1200)
        })
    }

    function init() {
        if (props.data) {
            setData({
                ...props.data,
                product_id: props.data.id,
                quantity: 0,
                reason: "Atualizar estoque",
                type: "2",
                stock_history: {
                    reason: "Atualizar estoque",
                    type: "2"
                }
            })
        }
    }
    React.useEffect(init, [props.data])

    return <React.Fragment>
        <SimpleButton
            id="update-stock-item-quantity"
            onClick={() => setShow(true)} >
            Atualizar estoque
        </SimpleButton>
        <Modal
            title="Atualizar a quantidade em estoque"
            show={show}
            onHide={onHide}>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="my-2">
                            <Text className="my-3">
                                Atualizar informações de estoque para o item: <strong>{props.name}</strong>
                            </Text>
                            <Text className="my-3">
                                Quantidade atual: {data.stock_quantity}
                            </Text>
                            <Text>
                                Nova quantidade: {
                                    data.type === "3" // saída manual do estoque
                                        ? data.stock_quantity - +data.quantity
                                        : data.stock_quantity + +data.quantity
                                }
                            </Text>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Razão
                                </Text>
                            </div>
                            <FormControl
                                autoFocus
                                name="reason"
                                disabled={loading}
                                onChange={onChange}
                                value={data.reason} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Tipo
                                </Text>
                            </div>
                            <FormControl
                                name="type"
                                disabled={loading}
                                onChange={onChange}
                                as="select">
                                <option value="2">Entrada Manual</option>
                                <option value="3">Saída Manual</option>
                                <option value="3">Retorno Manual</option>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Quantidade
                                </Text>
                            </div>
                            <FormControl
                                id="item-stock-quantity-input-quantity"
                                name="quantity"
                                disabled={loading}
                                onChange={onChange}
                                type="number"
                                value={data.quantity} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-3">
                        <div className="d-flex justify-content-end">
                            <Button disabled={loading} onClick={onSave}>
                                Atualizar Estoque
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Product/index.jsx